// JavaScript Document
// eslint-disable-next-line no-unused-vars
import { Person } from './fisPerson_v1';

// eslint-disable-next-line no-unused-vars
export default class User extends Person {
  token = null;
  application = 'NA';
  instance = 'NA';
  mutable = false;
  roles = [];
  token = 'MISSING';
  person = null;

  // additions for FWR
  userBuildings = [];
  recentBuildings = [];
  userCostCenters = [];

  userOrgs = [];

  constructor(obj) {
    super(obj);
    if (typeof obj === 'undefined' || obj == null) return;

    if (typeof obj.token !== 'undefined') this.token = obj.token;
    if (typeof obj.application !== 'undefined') this.application = obj.application;
    if (typeof obj.instance !== 'undefined') this.instance = obj.instance;
    if (typeof obj.mutable !== 'undefined') this.mutable = obj.mutable;
    if (typeof obj.roles !== 'undefined') this.roles = obj.roles;
    if (typeof obj.person !== 'undefined') {
      this.person = new Person(obj.person);
    }

    if (typeof obj.userBuildings !== 'undefined') this.userBuildings = obj.userBuildings;
    //    for (var i=0;obj.userBuildings.length;i++)
    //        this.userBuildings.push(new Building(obj.userBuildings[i]));

    if (typeof obj.recentBuildings !== 'undefined') this.recentBuildings = obj.recentBuildings;
    if (typeof obj.userCostCenters !== 'undefined') this.userCostCenters = obj.userCostCenters;
    if (typeof obj.userOrgs !== 'undefined') this.userOrgs = obj.userOrgs;
  }

  hasRole(role) {
    const has = this.roles.find((myRole) => myRole == role);
    if (typeof has === 'undefined') return false;
    return true;
  }
}

export { User };
